import React from "react";
import { StyledHome } from "../styles";
import mildred_img_3 from "../imgs/mildred_img_3.jpg";



const Home = (props) => {
  return (
    <StyledHome>
        <figure>
          <img src={mildred_img_3} alt="mildred_img"/>
        </figure>
      <div className="h2-cont">
        <h2>
          {" "}
          Hi! My name is Mildred Awuor.My aim is to create thoughtful and
          purposeful web applications.
        </h2>
      </div>
    </StyledHome>
  );
};

export default Home;
